import { AwsRum } from 'aws-rum-web'

let rumClient = null
let loginStartTime = null

export function initRum(config) {
  if (!config || !config.rumApplicationId || !config.rumIdentityPoolId) {
    return
  }

  try {
    rumClient = new AwsRum(config.rumApplicationId, '1.0.0', config.region, {
      sessionSampleRate: 1,
      identityPoolId: config.rumIdentityPoolId,
      // Route through the CloudFront distribution so requests appear
      // same-origin — the RUM dataplane rejects cross-origin requests
      // from *.bam.zone even when the AppMonitor domain is set to bam.zone.
      endpoint: `https://${window.location.hostname}`,
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
    })
  } catch (e) {
    console.warn('CloudWatch RUM failed to initialize', e)
  }
}

export function addRumUserAttributes(attrs) {
  if (!rumClient) {
    return
  }
  try {
    rumClient.addSessionAttributes(attrs)
  } catch (e) {
    // never let RUM errors surface to users
  }
}

export function recordRumError(error) {
  if (!rumClient) {
    return
  }
  try {
    rumClient.recordError(error)
  } catch (e) {
    // never let RUM errors surface to users
  }
}

// Record a custom event. Safe to call before initRum — events are silently dropped.
export function recordRumEvent(type, data) {
  if (!rumClient) {
    return
  }
  try {
    rumClient.recordEvent(type, data)
  } catch (e) {
    // never let RUM errors surface to users
  }
}

// Call when the login form is submitted to start the login→dashboard timer.
export function markLoginStart() {
  loginStartTime = performance.now()
}

// Call when the Login screen first becomes visible to record time-to-login-screen.
// Values over 60s indicate a suspended/backgrounded tab resuming, not a real load time.
export function recordTimeToLoginScreen() {
  const ms = Math.round(performance.now())
  if (ms > 60000) return
  recordRumEvent('com.bam.perf.time_to_login_screen', { ms })
}

// Call when the PrivateApp first mounts to record login→private-app time.
export function recordLoginToDashboard() {
  if (loginStartTime === null) {
    return
  }
  recordRumEvent('com.bam.perf.login_to_dashboard', {
    ms: Math.round(performance.now() - loginStartTime),
  })
  loginStartTime = null
}
